import { ChevronDown } from "lucide-react";
import { KEYS } from "platejs";
import { useEditorRef, useEditorSelector } from "platejs/react";
import { memo, useCallback, useState } from "react";
import { cn } from "../../tailwind-utils";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

const FONT_SIZES = [
  "10px",
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "24px",
  "30px",
  "36px",
] as const;

export const FontSizeToolbarButton = memo(function FontSizeToolbarButton() {
  const editor = useEditorRef();
  const [open, setOpen] = useState(false);

  const currentSize = useEditorSelector(
    (editor) => (editor.api.mark(KEYS.fontSize) as string) || "",
    [],
  );

  const displaySize = currentSize || "16px";

  const handleSelect = useCallback(
    (value: string) => {
      editor.tf.addMarks({ [KEYS.fontSize]: value });
      editor.tf.focus();
      setOpen(false);
    },
    [editor],
  );

  return (
    <DropdownMenu modal={false} onOpenChange={setOpen} open={open}>
      <DropdownMenuTrigger asChild>
        <button
          className={cn(
            "inline-flex h-7 items-center gap-1 rounded-sm px-2 text-xs text-muted-foreground",
            "hover:bg-accent hover:text-accent-foreground",
          )}
          type="button"
        >
          <span>{displaySize}</span>
          <ChevronDown className="size-3" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {FONT_SIZES.map((size) => (
          <DropdownMenuItem key={size} onSelect={() => handleSelect(size)}>
            <span style={{ fontSize: size }}>{size}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
});
